<template>
  <div class="hot">
    <div class="hot-top">特色推荐</div>

    <div class="list" v-loading="listLoading">
      <div
        v-for="(item, index) in lists"
        :key="index"
        class="flex flex-row list-item flex-top"
      >
        <div
          class="list-num flex flex-center flex-middle"
          :class="{ [`index${index + 1}`]: true }"
        >
          {{ index + 1 }}
        </div>
        <div class="list-con flex-1">
          <div class="list-name pointer" @click="toDetail(item)">
            {{ item.abilityName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { abilityList } from "@/api/hall";
export default {
  data() {
    return {
      lists: [],
      labTotal: 0,
      listLoading: false,
      page: {
        pageIndex: 1,
        pageSize: 20,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.listLoading = true;
      const { list } = await this.$axios
        .post(abilityList, {
          ...this.page,
          abilityHeatStatus: 1,
          abilityType: 0,
        })
        .finally(() => {
          this.listLoading = false;
        });
      this.lists = list;
    },

    toDetail({ laboratoryAbilityId }) {
      this.$jump.push({
        name: "checkProjectDetail",
        query: { id: laboratoryAbilityId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.hot {
  background: white;
  width: 100%;
  &-top {
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: white;
    font-size: 16px;
    background: url($oss-url + "home/title-bg/title-bg-1.png") no-repeat center
      center / cover;
    margin-bottom: 10px;
  }
  &-num {
    text-align: left;
    font-size: 14px;
    padding: 20px 15px;
    color: #999;
    span {
      color: #333;
      margin: 0 2px;
    }
  }
}
.list {
  // padding-right: 15px;
  padding-bottom: 10px;
  &-item {
    padding: 10px;
    border-bottom: 1px solid #e6e6e6;
  }
  &-num {
    width: 24px;
    height: 24px;
    border-radius: 12px;
    background: #005ca7;
    color: #fff;
    margin: 0 15px;
    font-size: 14px;
    font-weight: bolder;
  }
  &-name {
    font-size: 14px;
    color: #1c1c1c;
    // margin-bottom: 8px;
  }
  &-other {
    font-size: 12px;
    color: #666666;
    padding-bottom: 8px;
    border-bottom: 1px dashed #d1d1d1;
  }
}
.list-item:last-child {
  margin-bottom: 0;
  .list-other {
    border-bottom: none;
  }
}
</style>
